import { render, staticRenderFns } from "./orderManager.vue?vue&type=template&id=03d16ffe&scoped=true"
import script from "./orderManager.vue?vue&type=script&lang=js"
export * from "./orderManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d16ffe",
  null
  
)

export default component.exports